<button
  [type]="type()"
  [disabled]="disabled() || loading()"
  [ngClass]="variantStyles[variant()]"
  class="w-full text-[16px] font-semibold px-6 rounded-sm cursor-pointer flex items-center justify-center gap-3 not-disabled:hover:opacity-90 disabled:opacity-70 disabled:cursor-not-allowed py-{{
    py()
  }}"
>
  @if (iconName()) {
    <mat-icon
      [ngClass]="iconColorStyles[variant()]"
      [svgIcon]="iconName()"
      class="w-6 h-6"
    ></mat-icon>
  } @else if (iconSrc()) {
    <img [src]="iconSrc()" class="w-6 h-6" alt="icon" />
  }

  {{ text() }}
</button>
